const Component = {
  "图片 url 不存在": "URL gambar tidak ada",
  "暂不支持下载此类型图片": "Pengunduhan jenis gambar ini saat ini tidak didukung",
}

export default Component;